"use client"

import { useState } from "react"
import { DataImportCrmSource } from "@/schema/data-import"
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@ui/input-otp"
import { REGEXP_ONLY_DIGITS } from "input-otp"
import { Loader2 } from "lucide-react"

interface TwoFactorPromptProps {
  sourceType: DataImportCrmSource
  isPending: boolean
  error?: string | null
  onSubmit: (code: string) => void
}

export function TwoFactorPrompt({ sourceType, isPending, error, onSubmit }: TwoFactorPromptProps) {
  const [otpCode, setOtpCode] = useState("")

  const handleChange = (value: string) => {
    setOtpCode(value)
    if (value.length === 6) {
      onSubmit(value)
      setOtpCode("")
    }
  }

  return (
    <div className="mx-auto flex max-w-xl flex-col items-center gap-6 py-12">
      <div className="text-center">
        <h3 className="text-lg font-medium">Verification code required</h3>
        <p className="text-muted-foreground mt-1">
          {sourceType === "redtail" ? "Redtail" : "Wealthbox"} sent a passcode to your phone. Enter it below to
          continue.
        </p>
      </div>

      <InputOTP
        maxLength={6}
        pattern={REGEXP_ONLY_DIGITS}
        value={otpCode}
        onChange={handleChange}
        disabled={isPending}
        autoFocus
      >
        <InputOTPGroup>
          <InputOTPSlot index={0} />
          <InputOTPSlot index={1} />
          <InputOTPSlot index={2} />
          <InputOTPSlot index={3} />
          <InputOTPSlot index={4} />
          <InputOTPSlot index={5} />
        </InputOTPGroup>
      </InputOTP>

      {isPending && (
        <div className="flex items-center gap-2">
          <Loader2 className="text-muted-foreground h-4 w-4 animate-spin" />
          <p className="text-muted-foreground text-sm">Verifying...</p>
        </div>
      )}

      {error && <p className="text-red-accent text-sm">{error}</p>}
    </div>
  )
}
